import { css } from 'styled-components';
import { mb } from 'styled-components-spacing';

import theme from '@theme';

const {
  colors: {
    gray, black, defaultGreen, white, darkBlue, navyGray, greyBlue, mediumGray
  }
} = theme;

const link = ({ color = navyGray, colorHover = greyBlue }) => css`
  color: ${color};
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  &:active,
  &:visited,
  &:focus {
    color: ${color};
  }
  &:hover {
    color: ${colorHover};
  }
`;

const heroLink = ({ color }) => css`
  color: ${color};
  text-decoration: none;
  font-size: 18px;
  font-weight: 600;
  &:active,
  &:visited,
  &:focus {
    color: ${color};
  }
`;

export const fontLinkNoStyles = `
  text-decoration: none;
  color: inherit;
`;

export const fontLink = link({ color: navyGray });
export const fontLinkActive = link({ color: defaultGreen });
export const fontLinkGreen = link({ color: defaultGreen });
export const HeroNavBar = heroLink({ color: white });

export const fontLight = css`
  color: ${gray};
`;

export const fontTeaserBold = css`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.44;
  ${mb(2)}
`;

export const fontTeaserItalic = `
  font-size: 16px;
  color: ${gray};
  text-transform: italic;
  font-style: italic;
`;

export const fontHeadlineDefault = css`
  font-size: 24px;
  font-weight: 500;
  ${mb(4)}
`;

export const fontCopyDefault = css`
  font-size: 18px;
  line-height: 1.44;
`;

export const fontHeadingSubDark = css`
  font-family: Raleway;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  text-align: left;
  color: ${darkBlue};
`;

export const fontHeadingSubDarkCenter = css`
  font-family: Raleway;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  text-align: center;
  color: ${darkBlue};
`;

export const fontHeadingLight = css`
  font-family: 'Open Sans', OpenSans, Raleway;
  font-size: 20px;

  font-weight: normal;

  line-height: 1.6;
  letter-spacing: normal;
  color: ${mediumGray};
`;

export const fontHeadingSubLight = css`
  font-family: Raleway;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  text-align: left;
  color: ${white};
`;

export const fontLargeHeading = css`
  font-family: Raleway;
  font-size: 40px;
  font-weight: 500;
  font-style: normal;
  line-height: 1.4;
`;

export const fontButtonLink = link({ color: defaultGreen });
export const fontButtonLinkHighlighted = link({ color: white, colorHover: white });
export const fontButtonLinkDark = link({ color: black, colorHover: black });
export const fontButtonLinkBright = link({ color: white, colorHover: white });
